import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { BaseButton, Sidebar } from "@velocity-ehs/component-library";
import { Input } from "../../sharedComponents/inputs/Input";
import { useTranslation } from "react-i18next";

interface Props {
  showSlider: boolean;
  closeSliderCallback: () => void;
  addHierarchy: (name: string) => void;
}

const AddHierarchySlider: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    reset,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<{ name: string }>({
    mode: "onBlur",
  });

  const handleAddHierarchy = async () => {
    const { name } = getValues();
    await props.addHierarchy(name);
  };

  useEffect(() => {
    reset();
    // eslint-disable-next-line
  }, [props.showSlider]);

  return (
    <Sidebar
      header={t("hierarchies_Add_Hierarchies_Text")}
      visible={props.showSlider}
      onHide={props.closeSliderCallback}
      footer={
        <BaseButton
          form="addHierarchyForm"
          type="submit"
          loading={isSubmitting}
          label={t("universal_Add")}
        />
      }
    >
      <form id="addHierarchyForm" onSubmit={handleSubmit(handleAddHierarchy)}>
        <Input
          control={control}
          name="name"
          label={t("universal_Name")}
          rules={{
            required: t("customer_Form_Name_Required"),
            maxLength: {
              value: 100,
              message: t("max_length_100_char_form_validation"),
            },
          }}
          helpText={t("hierarchies_Add_Hierarchies_Description_Text")}
          errorMessage={errors ? errors.name?.message : undefined}
        />
      </form>
    </Sidebar>
  );
};

export default AddHierarchySlider;
